"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gap = exports.view = void 0;

var _util = require("../../../util");

const view = ({
  cssProps,
  theme
}) => {
  const {
    alignContent,
    alignItems,
    alignSelf,
    flex: flexProp,
    flexDirection,
    flexWrap,
    inline,
    justifyContent,
    overflow,
    margin,
    padding,
    flexGrow
  } = cssProps;
  return {
    alignContent,
    alignItems,
    alignSelf,
    flex: flexProp ? '1 1 auto' : undefined,
    display: inline ? 'inline-flex' : 'flex',
    flexDirection,
    flexWrap,
    justifyContent,
    overflow,
    margin: margin !== 0 && !!margin ? (0, _util.spacing)(theme, margin) : undefined,
    padding: padding !== 0 && !!padding ? (0, _util.spacing)(theme, padding) : undefined,
    flexGrow
  };
};

exports.view = view;

const gap = ({
  cssProps,
  theme
}) => {
  const {
    gap: gapProp = 0
  } = cssProps;
  return { ...view({
      cssProps: { ...cssProps,
        inline: false
      },
      theme
    }),
    height: "calc(100% + ".concat((0, _util.spacing)(theme, gapProp), "px)"),
    margin: -((0, _util.spacing)(theme, gapProp) / 2),
    width: "calc(100% + ".concat((0, _util.spacing)(theme, gapProp), "px)"),
    '& > *': {
      margin: (0, _util.spacing)(theme, gapProp) / 2
    }
  };
};

exports.gap = gap;
//# sourceMappingURL=View.style.js.map